<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">会员管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="状态：">
                    <el-select v-model="query.status" clearable>
                        <el-option v-for="(item, index) in status" :key="index" :label="item.label" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="　昵称：">
                    <el-input placeholder="请输入昵称" v-model="query.nickname"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <hr/>
        <div class="title">
            <span>会员列表</span>
        </div>
        <el-table highlight-current-row :data="members" ref="multipleTable"
                  @expand-change="changeDiagram" @selection-change="handleSelectionChange">
            <el-table-column align="center" type="expand">
                <template slot-scope="scope">
                    <el-row>
                        <el-col>
                            <div :id="scope.row.id" :style="{height: '450px',width:'100%'}">
                            </div>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column align="center" label="头像">
                <template slot-scope="scope">
                    <el-image style="height: 75px; width: 75px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                              :src="scope.row.iconPath">
                        <div slot="error" class="image-slot">
                            <el-image title="加载失败"
                                      src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
                        </div>
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column align="center" label="昵称" prop="nickname"/>
            <el-table-column align="center" label="性别">
                <template slot-scope="scope">
                    <span>{{ '1' == scope.row.gender ? '男' : '女' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="电话">
                <template slot-scope="scope">
                    <span>{{ scope.row.mobile || '未授权电话' }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="等级">
                <template slot-scope="scope">
                    <span>{{ levelMap[scope.row.level] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                    <span>{{ statusMap[scope.row.status] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="积分">
                <template slot-scope="scope">
                    <span>{{ (scope.row.remainder && scope.row.remainder.INTEGRAL) || 0}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="余额">
                <template slot-scope="scope">
                    <span>￥{{ (scope.row.remainder && scope.row.remainder.RMB) || 0}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="注册时间" prop="createTime"/>
            <el-table-column align="center" label="操作" width="250px">
                <template slot-scope="scope">
                    <el-tooltip content="用户详情" placement="top"
                                effect="light">
                        <el-button type="primary"
                                   @click="$common.goRouterLink({ name: 'MemberDetail', query: { memberId: scope.row.id }})"
                                   size="mini"
                                   icon="el-icon-edit" round/>
                    </el-tooltip>

                    <el-tooltip content="设置为角色" placement="top" effect="light">
                        <el-dropdown @command="handleCommand" trigger="click">
                            <el-button type="primary" size="mini" round icon="el-icon-s-tools"/>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item,i) in level" v-bind:key="i"
                                                  :command="beforeHandleCommand(scope.row.userId,item.name)"
                                                  icon="el-icon-s-custom">{{ item.label }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-tooltip>

                    <el-tooltip content="订单列表" placement="top" effect="light">
                        <el-button type="primary"
                                   @click="$common.goRouterLink({ name: 'orderList', query: { userId: scope.row.userId }})"
                                   size="mini" icon="el-icon-s-order" round/>
                    </el-tooltip>

                    <el-tooltip content="送优惠券" placement="top"
                                effect="light">
                        <el-button type="primary"
                                   @click="$refs['send-coupon'].open(scope.row);"
                                   size="mini"
                                   icon="el-icon-present" round/>
                    </el-tooltip>

                </template>
            </el-table-column>
        </el-table>
        <vue-pager v-bind:datafile="fillData" url="member/pageMember" v-bind:query="query" ref="pager"
                   v-bind:init="true"></vue-pager>
        <send-coupon ref="send-coupon"></send-coupon>
    </div>
</template>
<script>
    import sendCoupon from './components/send-coupon.vue'

    export default {
        data() {
            return {
                loading: true,
                members: [],
                level: [],
                levelMap: {},
                status: [],
                statusMap: {},
                query: {},
                checkInputs: [],

                spaceTypeMap: {},

                dynamicPath: config.dynamicResourcePath,
                multipleSelection: [],
            }
        },
        components: {sendCoupon},
        created() {
            var _this = this;
            _this.level = _this.$common.enum_config('EMemberLevel');
            _this.level && _this.level.forEach((item) => {
                _this.levelMap[item.name] = item.label;
            });
            //_this.level.splice(0, 0, {'name': null, 'label': '全部'})
            _this.status = _this.$common.enum_config('EMemberStatus');
            _this.status && _this.status.forEach((item) => {
                _this.statusMap[item.name] = item.label;
            });
            _this.status.splice(0, 0, {'name': null, 'label': '全部'})
        },
        methods: {
            beforeHandleCommand(memberId, level) {
                return {
                    'memberId': memberId,
                    'level': level
                }
            },
            handleCommand(command) {
                const _this = this;
                _this.$common.my_ajax({
                    url: 'member/saveMemberInfo',
                    data: {
                        userId: command.memberId,
                        level: command.level
                    },
                    success: function () {
                        _this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function () {
                                _this.submitQuery(_this.query.current);
                            }
                        });
                    }
                });
            },
            changeDiagram(row, expanded) {
                let _this = this;
                setTimeout(() => {
                    const element = document.getElementById(row.id);
                    if (element && !element.hasChildNodes()) {
                        let myChart = _this.$echarts.init(element);
                        myChart.showLoading();
                        _this.$common.my_ajax({
                            url: 'memberRelation/findUserMemberRelation',
                            data: {
                                userId: row.id
                            },
                            success: function (response) {
                                // 绘制图表
                                let categoriesArray = response.item.categoriesArray;
                                let categories = [];
                                categoriesArray.forEach((v, i) => {
                                    categories[i] = {
                                        name: v
                                    };
                                })
                                let option = {
                                    title: {
                                        text: '角色关系图',
                                        subtext: 'Circular layout',
                                        top: 'bottom',
                                        left: 'right'
                                    },
                                    tooltip: {
                                        formatter: '{c}'
                                    },
                                    legend: [{
                                        data: categories.map(function (a) {
                                            return a.name;
                                        })
                                    }],
                                    animationDurationUpdate: 1500,
                                    animationEasingUpdate: 'quinticInOut',
                                    series: [
                                        {
                                            type: 'graph',
                                            layout: 'circular',
                                            data: response.item.views,
                                            links: response.item.links,
                                            categories: categories,
                                            roam: true,
                                            label: {
                                                show: true,
                                                position: 'right',
                                                formatter: '{b}'
                                            },
                                            lineStyle: {
                                                color: 'source',
                                                curveness: 0.3
                                            }
                                        }
                                    ],
                                };
                                myChart.setOption(option);
                                myChart.hideLoading();
                            },
                            failure: () => {
                                myChart.hideLoading();
                            }
                        });
                    }
                }, 1000);
            },
            handleSelectionChange(val) {
                this.checkInputs = val;
            },
            deleteMember(_memberId) {
                var _this = this;
                _this.$common.my_ajax({
                    url: 'member/deleteMember',
                    data: {
                        memberId: _memberId
                    },
                    success: function (response) {
                        _this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function () {
                                _this.submitQuery(_this.query.current);
                            }
                        });
                    }
                });
            },
            fillData(response) {
                let _this = this;
                let items = response.items || [];
                items.forEach((value, index) => {
                    if (value.iconPath) {
                        if (!value.iconPath.startsWith('https') && value.iconPath.startsWith('http')) {
                            value.iconPath = _this.dynamicPath + value.iconPath;
                        }
                    }
                    if (value.remainder) {
                        try {
                            value.remainder = JSON.parse(value.remainder)
                        } catch (e) {
                            console.log(e);
                        }
                    }
                });
                this.members = items;
            },
            submitQuery(_num) {
                var _this = this;
                _this.members = [];
                _this.$refs.pager.gotoPage(_num);
            },
        },
    }
</script>
<style scoped>
</style>
